<template>
    <!-- Dummy toggle for designers to see layout on web -->
    <UISimple
        v-if="faking"
        :class="{ 'pointer-events-none': faking }"
    >
        <template #title>
            <span class="opacity-30">{{ title }}</span>
        </template>
        <template #right-content>
            <DSwitch
                :model-value="true"
                class="opacity-30"
            />
        </template>
    </UISimple>
    <UISimple
        v-else-if="pushNotifications.available"
        @click="toggleNotifications"
    >
        <template #title>
            {{ title }}
        </template>
        <template #right-content>
            <DSwitch
                :model-value="enabled"
                class="pointer-events-none"
            />
        </template>
    </UISimple>
</template>

<script setup>
    import { DSwitch } from '@digistorm/spark'
    import { onBeforeUnmount } from 'vue'
    import { storeToRefs } from 'pinia'
    import { modalController } from '@ionic/vue'
    import { App } from '@capacitor/app'
    import UISimple from '@/components/ui/ListItemLayouts/UISimple.vue'
    import NotificationsDisabledModal
        from '@/components/app/settings/NotificationsDisabledModal.vue'

    const props = defineProps({
        config: Object,
        title: {
            type: String,
            default: 'Notifications',
        },
    })

    const emit = defineEmits(['toggle'])

    const appStore = useAppStore()
    const deviceStore = useDeviceStore()
    const pushNotifications = usePushNotifications()

    const { mockData } = storeToRefs(appStore)
    const { isWeb } = storeToRefs(deviceStore)
    const enabled = ref(true)
    const denied = ref(false)
    let listener = null

    const faking = computed(() => {
        return isWeb.value || mockData.value
    })

    const showNotificationsDisabledMessage = async () => {
        const modal = await modalController.create({
            cssClass: 'ds-modal-bottom-sheet',
            component: NotificationsDisabledModal,
            componentProps: {
                onCancelled: () => {
                    modal.dismiss()
                },
            },
            initialBreakpoint: 0.55,
            breakpoints: [0, 0.55],
        })

        await modal.present()
    }

    const toggleNotifications = async () => {
        if (denied.value) {
            await showNotificationsDisabledMessage()
            return
        }

        if (enabled.value) {
            await pushNotifications.disable()
        } else {
            await pushNotifications.enable()
        }

        enabled.value = !enabled.value
        emit('toggle', enabled.value)
    }

    const handleApiRegistrationError = () => {
        enabled.value = false
        emit('toggle', enabled.value)
    }

    const checkNotifications = async () => {
        if (!pushNotifications.available) {
            return
        }
        enabled.value = await pushNotifications.enabled()
        denied.value = await pushNotifications.denied()
    }

    onBeforeMount(async () => {
        if (!pushNotifications.available) {
            return
        }
        checkNotifications()
        pushNotifications.events.on('apiRegistrationError', handleApiRegistrationError)
        listener = App.addListener('resume', (event) => {
            checkNotifications()
        })
    })

    onBeforeUnmount(() => {
        pushNotifications.events.off('apiRegistrationError', handleApiRegistrationError)
        listener?.remove()
    })
</script>
